export const normalizeOrderCoupon = (rawCoupon) => {
    if (!rawCoupon || typeof rawCoupon !== 'object') return null

    const stripeCoupon = rawCoupon.object === 'promotion_code' && rawCoupon.coupon && typeof rawCoupon.coupon === 'object'
        ? rawCoupon.coupon
        : rawCoupon
    const code = rawCoupon.code
        ?? (rawCoupon.object === 'coupon' ? rawCoupon.id : null)
        ?? rawCoupon.name
        ?? stripeCoupon.id

    if (!code) return null

    return {
        code: String(code),
        amountOff: stripeCoupon.amount_off ?? rawCoupon.amount_off ?? null,
        percentOff: stripeCoupon.percent_off ?? rawCoupon.percent_off ?? null,
    }
}
